var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProperty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4528 28.9128C37.4528 33.0629 36.5765 36.4291 35.4925 36.4291C34.4086 36.4291 33.5322 33.0629 33.5322 28.9128C33.5322 24.7627 34.4086 21.3965 35.4925 21.3965C36.5765 21.3965 37.4528 24.7627 37.4528 28.9128Z",
    fill: "#90C142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8383 33.5702L35.6769 29.6276L37.0606 27.6908L36.1612 28.7053L35.6538 29.4201L35.4924 25.708L35.3309 29.5353L35.2156 29.4201L34.0625 27.4603L35.1464 29.4662V29.4892L35.3309 29.6737L35.377 31.864L34.0625 30.4576L35.3309 32.1407V33.2935L35.4001 40.7176H35.9075L35.8614 33.893L36.7377 32.1868L35.8383 33.5702Z",
    fill: "#68412E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67526 35.2534C4.15276 35.2534 5.3505 30.6598 5.3505 24.9934C5.3505 19.327 4.15276 14.7334 2.67526 14.7334C1.19776 14.7334 0 19.327 0 24.9934C0 30.6598 1.19776 35.2534 2.67526 35.2534Z",
    fill: "#90C142"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13604 31.3569L2.90542 25.9848L4.79653 23.3333L3.57422 24.6936L2.88234 25.6851L2.67479 20.6357L2.44417 25.8465L2.28272 25.6851L0.691406 22.9875L2.19047 25.7542V25.7773L2.44417 26.0309L2.51335 29.0051L0.691406 27.1145L2.42109 29.3971L2.44417 30.9649L2.51335 40.9021L3.22828 40.9252L3.1591 31.7949L4.35835 29.4432L3.13604 31.3569Z",
    fill: "#68412E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M14.76 0.991211H12.6152V5.30272H14.76V0.991211Z",
    fill: "#C45F1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1062 0.599609H12.2695V0.991555H15.1062V0.599609Z",
    fill: "#994313"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1062 2.4668H12.2695V2.81263H15.1062V2.4668Z",
    fill: "#994313"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.76 0.991211H12.6152V1.24484H14.76V0.991211Z",
    fill: "#3D1C05"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.76 2.81348H12.6152V3.06709H14.76V2.81348Z",
    fill: "#3D1C05"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.919 12.4045V40.1642H6.1582V12.2892L11.8085 6.04102H26.5224L31.919 12.4045Z",
    fill: "#F2AC7C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7257 37.5352H5.16602V40.5786H32.7257V37.5352Z",
    fill: "#774422"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M27.9984 8.39274H10.2402L11.8085 6.04102H26.5224L27.9984 8.39274Z",
    fill: "#44240E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 18.2363H8.46387V25.8679H12.2V18.2363Z",
    fill: "#06634D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2001 18.2363H11.5312V25.8679H12.2001V18.2363Z",
    fill: "#05382B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 18.3291H10.1475V25.8685H10.332V18.3291Z",
    fill: "#FFF9F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34863 18.0996V26.0079H12.3154V18.0996H8.34863ZM12.0848 25.7312H8.57926V18.3763H12.0848V25.7312Z",
    fill: "#FFF9F3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M12.9381 25.7994V26.0069H12.7536V18.0986H12.3154V26.0069V26.1683V26.3297H12.7536V26.1683H13.1226V26.1452V26.0069V25.7994H12.9381Z",
    fill: "#4C250B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6382 25.7998H8.04883V26.3301H12.6382V25.7998Z",
    fill: "#C1B7AE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M12.6382 26.0068H8.04883V26.1682H12.6382V26.0068Z",
    fill: "#4C250B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9381 25.7998H7.74902V26.0073H12.9381V25.7998Z",
    fill: "#FFF9F3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2645 18.2363H17.5283V25.8679H21.2645V18.2363Z",
    fill: "#06634D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2411 18.2363H20.5723V25.8679H21.2411V18.2363Z",
    fill: "#05382B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3964 18.3291H19.2119V25.8685H19.3964V18.3291Z",
    fill: "#FFF9F3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3896 18.0996V26.0079H21.3564V18.0996H17.3896ZM21.1258 25.7312H17.6203V18.3763H21.1258V25.7312Z",
    fill: "#FFF9F3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M21.9791 25.7994V26.0069H21.7946V18.0986H21.3564V26.0069V26.1683V26.3297H21.7946V26.1683H22.1636V26.1452V26.0069V25.7994H21.9791Z",
    fill: "#4C250B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7027 25.7998H17.1133V26.3301H21.7027V25.7998Z",
    fill: "#C1B7AE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M21.7027 26.0068H17.1133V26.1682H21.7027V26.0068Z",
    fill: "#4C250B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9791 25.7998H16.79V26.0073H21.9791V25.7998Z",
    fill: "#FFF9F3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2625 28.1055H20.5264V35.7371H24.2625V28.1055Z",
    fill: "#06634D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2391 28.1055H23.5703V35.7371H24.2391V28.1055Z",
    fill: "#05382B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3945 28.1973H22.21V35.7366H22.3945V28.1973Z",
    fill: "#FFF9F3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3877 27.9668V35.8751H24.3544V27.9668H20.3877ZM24.1238 35.5984H20.6183V28.2435H24.1238V35.5984Z",
    fill: "#FFF9F3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M24.9772 35.6676V35.8751H24.7927V27.9668H24.3545V35.8751V36.0364V36.1978H24.7927V36.0364H25.1617V36.0134V35.8751V35.6676H24.9772Z",
    fill: "#4C250B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7008 35.668H20.1113V36.1983H24.7008V35.668Z",
    fill: "#C1B7AE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M24.7008 35.875H20.1113V36.0364H24.7008V35.875Z",
    fill: "#4C250B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9771 35.668H19.7881V35.8755H24.9771V35.668Z",
    fill: "#FFF9F3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2117 28.1055H26.4756V35.7371H30.2117V28.1055Z",
    fill: "#06634D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2118 28.1055H29.543V35.7371H30.2118V28.1055Z",
    fill: "#05382B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3437 28.1973H28.1592V35.7366H28.3437V28.1973Z",
    fill: "#FFF9F3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3604 27.9668V35.8751H30.3271V27.9668H26.3604ZM30.0965 35.5984H26.591V28.2435H30.0965V35.5984Z",
    fill: "#FFF9F3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M30.9498 35.6676V35.8751H30.7653V27.9668H30.3271V35.8751V36.0364V36.1978H30.7653V36.0364H31.1343V36.0134V35.8751V35.6676H30.9498Z",
    fill: "#4C250B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.65 35.668H26.0605V36.1983H30.65V35.668Z",
    fill: "#C1B7AE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M30.65 35.875H26.0605V36.0364H30.65V35.875Z",
    fill: "#4C250B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9498 35.668H25.7607V35.8755H30.9498V35.668Z",
    fill: "#FFF9F3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0281 18.2363H26.292V25.8679H30.0281V18.2363Z",
    fill: "#06634D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0047 18.2363H29.3359V25.8679H30.0047V18.2363Z",
    fill: "#05382B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1601 18.3291H27.9756V25.8685H28.1601V18.3291Z",
    fill: "#FFF9F3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1768 18.0996V26.0079H30.1435V18.0996H26.1768ZM29.9129 25.7312H26.4074V18.3763H29.9129V25.7312Z",
    fill: "#FFF9F3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M30.7662 25.7994V26.0069H30.5817V18.0986H30.1436V26.0069V26.1683V26.3297H30.5817V26.1683H30.9507V26.1452V26.0069V25.7994H30.7662Z",
    fill: "#4C250B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4664 25.7998H25.877V26.3301H30.4664V25.7998Z",
    fill: "#C1B7AE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M30.4664 26.0068H25.877V26.1682H30.4664V26.0068Z",
    fill: "#4C250B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7428 25.7998H25.5537V26.0073H30.7428V25.7998Z",
    fill: "#FFF9F3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.3134 10.0059C14.2756 10.0059 13.4453 10.7437 13.4453 11.6659V15.9774H17.1584V11.6659C17.1584 10.7437 16.3281 10.0059 15.3134 10.0059Z",
    fill: "#4C250B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 15.8613V11.642C13.5371 10.789 14.229 10.0742 15.1054 10.0742C15.9587 10.0742 16.6736 10.7659 16.6736 11.642V15.8613H13.5371Z",
    fill: "#1C7C63"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 15.8613V11.642C13.5371 10.789 14.229 10.0742 15.1054 10.0742C15.9587 10.0742 16.6736 10.7659 16.6736 11.642V15.8613H13.5371Z",
    fill: "#1C7C63"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2904 10.1207C15.2212 10.1207 15.1521 10.0977 15.0829 10.0977C14.2296 10.0977 13.5146 10.7894 13.5146 11.6655V15.8848H13.9298V11.6655C13.9298 10.8585 14.5294 10.2129 15.2904 10.1207Z",
    fill: "#2A5146"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5817 12.1031H15.1057V10.1895H14.9674V12.1031H13.5605V12.1953H14.9674V15.8613H15.1057V12.1953H16.5817V12.1031Z",
    fill: "#2A5146"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1058 10.0059C14.1833 10.0059 13.4453 10.7437 13.4453 11.6659V15.9774H16.7433V11.6659C16.7433 10.7437 16.0052 10.0059 15.1058 10.0059ZM16.5587 15.7699H13.6068V11.6428C13.6068 10.8359 14.2756 10.1673 15.0828 10.1673C15.8899 10.1673 16.5587 10.8359 16.5587 11.6428V15.7699Z",
    fill: "#FFF9F3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.7167 10.0059C21.6789 10.0059 20.8486 10.7437 20.8486 11.6659V15.9774H24.5617V11.6659C24.5848 10.7437 23.7545 10.0059 22.7167 10.0059Z",
    fill: "#4C250B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9404 15.8613V11.642C20.9404 10.789 21.6323 10.0742 22.5087 10.0742C23.362 10.0742 24.0769 10.7659 24.0769 11.642V15.8613H20.9404Z",
    fill: "#1C7C63"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9404 15.8613V11.642C20.9404 10.789 21.6323 10.0742 22.5087 10.0742C23.362 10.0742 24.0769 10.7659 24.0769 11.642V15.8613H20.9404Z",
    fill: "#1C7C63"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7162 10.1207C22.6471 10.1207 22.5779 10.0977 22.5087 10.0977C21.6554 10.0977 20.9404 10.7894 20.9404 11.6655V15.8848H21.3556V11.6655C21.3556 10.8585 21.9552 10.2129 22.7162 10.1207Z",
    fill: "#2A5146"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M23.985 12.1031H22.5091V10.1895H22.3707V12.1031H20.9639V12.1953H22.3707V15.8613H22.5091V12.1953H23.985V12.1031Z",
    fill: "#2A5146"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5091 10.0059C21.5866 10.0059 20.8486 10.7437 20.8486 11.6659V15.9774H24.1466V11.6659C24.1696 10.7437 23.4316 10.0059 22.5091 10.0059ZM23.9851 15.7699H21.0331V11.6428C21.0331 10.8359 21.7019 10.1673 22.5091 10.1673C23.3163 10.1673 23.9851 10.8359 23.9851 11.6428V15.7699Z",
    fill: "#FFF9F3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3608 5.76395H11.8545L12.5233 5.34894L13.0307 5.02615L13.0768 4.98005L13.5842 4.65726L13.6534 4.63421L14.1377 4.31141L14.2069 4.2653L14.6912 3.94252L14.7604 3.89641L15.2677 3.59668L15.3139 3.55056L15.8212 3.22777L15.8904 3.18166L16.3747 2.88193L16.4439 2.83581L16.9282 2.51304L16.9974 2.46692L17.4817 2.16719L17.5509 2.12108L18.0583 1.79829L18.1044 1.75219L18.6118 1.45244L18.681 1.40634L19.0269 1.17578L19.1653 1.268L19.2345 1.29106L19.7188 1.61384L19.788 1.6369L20.2954 1.95968L20.3415 2.0058L20.8489 2.30552L20.9181 2.35164L21.4024 2.65137L21.4716 2.69748L21.9559 2.99721L22.025 3.04332L22.5324 3.36612L22.5786 3.38917L23.0859 3.71196L23.1551 3.75806L23.6394 4.0578L23.7086 4.1039L24.1929 4.40364L24.2621 4.44974L24.7695 4.74949L24.8156 4.79559L25.323 5.11838L25.3922 5.14143L25.8765 5.46422L26.3608 5.76395Z",
    fill: "#542A0E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M13.0308 5.02734V5.76515H12.5234V5.35014L13.0308 5.02734Z",
    fill: "#381904"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M13.5845 4.6582V5.7649H13.0771V4.98099L13.5845 4.6582Z",
    fill: "#381904"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.1376 4.3125V5.76503H13.6533V4.63529L14.1376 4.3125Z",
    fill: "#381904"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.6913 3.94336V5.76479H14.207V4.26614L14.6913 3.94336Z",
    fill: "#381904"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M15.2681 3.59766V5.76492H14.7607V3.89738L15.2681 3.59766Z",
    fill: "#381904"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M15.8218 3.22852V5.76469H15.3145V3.55131L15.8218 3.22852Z",
    fill: "#381904"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.3749 2.88281V5.76484H15.8906V3.18254L16.3749 2.88281Z",
    fill: "#381904"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.9286 2.51367V5.76457H16.4443V2.83645L16.9286 2.51367Z",
    fill: "#381904"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.4824 2.16797V5.76473H16.998V2.4677L17.4824 2.16797Z",
    fill: "#381904"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.0581 1.7998V5.76547H17.5508V2.1226L18.0581 1.7998Z",
    fill: "#381904"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.6119 1.45312V5.76462H18.1045V1.75287L18.6119 1.45312Z",
    fill: "#381904"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.165 1.26897V5.76493H18.6807V1.40732L19.0266 1.17676L19.165 1.26897Z",
    fill: "#381904"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.7187 1.61477V5.76487H19.2344V1.29199L19.7187 1.61477Z",
    fill: "#381904"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M20.2954 1.96047V5.76474H19.7881V1.6377L20.2954 1.96047Z",
    fill: "#381904"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M20.8492 2.30656V5.76498H20.3418V2.00684L20.8492 2.30656Z",
    fill: "#381904"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.4023 2.65227V5.76485H20.918V2.35254L21.4023 2.65227Z",
    fill: "#381904"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.956 2.99797V5.76472H21.4717V2.69824L21.956 2.99797Z",
    fill: "#381904"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.5328 3.36674V5.76456H22.0254V3.04395L22.5328 3.36674Z",
    fill: "#381904"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M23.0855 3.71244V5.76443H22.5781V3.38965L23.0855 3.71244Z",
    fill: "#381904"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M23.6396 4.05853V5.76467H23.1553V3.75879L23.6396 4.05853Z",
    fill: "#381904"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.1933 4.40423V5.76454H23.709V4.10449L24.1933 4.40423Z",
    fill: "#381904"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M24.7701 4.75091V5.76537H24.2627V4.45117L24.7701 4.75091Z",
    fill: "#381904"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M25.3228 5.11966V5.76523H24.8154V4.79688L25.3228 5.11966Z",
    fill: "#381904"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M25.8769 5.46537V5.76509H25.3926V5.14258L25.8769 5.46537Z",
    fill: "#381904"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0269 1.17578L11.8545 5.76395H13.4919L19.8572 1.68301L19.0269 1.17578Z",
    fill: "#3D1C05"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.8969 27.9209H11.5547V38.3884H17.8969V27.9209Z",
    fill: "#774422"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4124 28.4746H12.085V38.4118H17.4124V28.4746Z",
    fill: "#4C1207"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.3893 28.4746H12.085V29.4199V38.4118H12.7999V29.4199H17.3893V28.4746Z",
    fill: "#4C2D18"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0351 38.3418H11.4854V38.5032H18.0351V38.3418Z",
    fill: "#E5C8B5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7578 38.5029H11.6924V39.0563H17.7578V38.5029Z",
    fill: "#B2998B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M17.7578 38.5029H11.6924V38.6874H17.7578V38.5029Z",
    fill: "#60493E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4272 39.0566H11.0703V39.218H18.4272V39.0566Z",
    fill: "#E5C8B5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1507 39.2188H11.3242V39.7721H18.1507V39.2188Z",
    fill: "#B2998B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M18.1507 39.2188H11.3242V39.4032H18.1507V39.2188Z",
    fill: "#60493E"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7266 39.7715H10.5625V39.9559H18.7266V39.7715Z",
    fill: "#E5C8B5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4034 39.9561H10.8389V40.5786H18.4034V39.9561Z",
    fill: "#B2998B"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M18.4034 39.9561H10.8389V40.1635H18.4034V39.9561Z",
    fill: "#60493E"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6508 28.9131H12.5918V34.7232H16.6508V28.9131Z",
    fill: "#06634D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5225 28.8203V34.8149H16.766V28.8203H12.5225ZM16.5815 30.8493H14.7365V29.0048H16.5815V30.8493ZM14.7365 31.0337H16.5815V32.6015H14.7365V31.0337ZM14.5289 29.0048V30.8493H12.707V29.0048H14.5289ZM14.5289 32.6015H12.707V31.0337H14.5289V32.6015ZM12.6839 32.786H14.5058V34.6535H12.6839V32.786ZM14.7365 34.6535V32.786H16.5815V34.6535H14.7365Z",
    fill: "#FFF9F3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93571 13.9721L4.40527 13.4879L11.6469 5.67188H26.6145L32.9797 13.0729L32.4493 13.5571L26.2916 6.38661H11.9698L4.93571 13.9721Z",
    fill: "#211106"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3069 40.5791H1.26855V40.9711H38.3069V40.5791Z",
    fill: "#211106"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.b3337276.svg";
export { ForwardRef as ReactComponent };